module.exports = __webpack_public_path__ + "img/gwnu_main2.68c79c51.jpg";